import type { DrawNumber } from '../../../../schema/draw/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import type { IGetMarketplaceBalanceUseCase, IMarketplaceGroupsService } from '../../../domain/entry.js';

type GetMarketplaceBalanceUseCaseParams = {
  product: Definition['drawProducts'][number];
  drawNumber: DrawNumber;
};

/**
 * Creates a use case for retrieving marketplace balance.
 *
 * @param marketplaceGroupsService - The service used to fetch marketplace balance
 * @returns A use case object with an execute method for getting marketplace balance
 */
export function getMarketplaceBalanceUseCase(
  marketplaceGroupsService: IMarketplaceGroupsService
): IGetMarketplaceBalanceUseCase {
  return {
    execute: async ({
      product,
      drawNumber,
    }: GetMarketplaceBalanceUseCaseParams): ReturnType<IGetMarketplaceBalanceUseCase['execute']> => {
      const response = await marketplaceGroupsService.getMarketplaceBalanceAsync({ product, drawNumber });

      return response;
    },
  };
}
